<template>
    <div class="page-container" :class="{'has-breadcrumb': profile.isSharpAdmin()}">
        <div v-if="profile.isSharpAdmin()" class="px-8 md:px-5 py-5 ">
            <breadcrumb></breadcrumb>
        </div>

        <div class="px-8 md:px-5 py-5 ">
            <h1 v-if="isAdding" class="mb-6">
                Add Staff
            </h1>
            <h1 v-else class="mb-6">
                Edit Staff
            </h1>

            <div>
                <admin-form :userID="$route.params.userID"  ></admin-form>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import AdminForm from './form/AdminForm.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';

    export default {
        components: {
            AdminForm,
            Breadcrumb
        },

        created: function () {
            let text = 'Add Staff';
            if(this.$router.currentRoute.value.params.userID){
                text = 'Edit Staff';
            }

            this.setPaths([
                {
                    text: 'Sharp Admin',
                    name: 'adminClients'
                },
                {
                    text: text,
                    isText: true
                }
            ]);
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),

            isAdding: function () {
                return !this.$router.currentRoute.value.params.userID;
            }
        },

        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            })
        }
    }
</script>
